import axios from 'axios'

import { VendorUserRoles, VendorUserTiers } from 'common/server/server_types'

interface IndexVendorUserResponse {
  vendor_users: ManagedVendorUser[]
}

export interface ManagedVendorUser {
  id: string
  name: string
  first_name: string
  last_name: string
  role: VendorUserRoles
  email: string
  confirmed_at: string
  last_sign_in_at: string
  invitation_sent_at: string
  invitation_link?: string
  invitation_expires_at?: string
  created_at: string
  is_public: boolean
  is_active: boolean
  deactivated_at?: string
  tier: VendorUserTiers
  can_manage_users: boolean
  resendInvitation: (id: string) => Promise<void>
}

export interface UpdateRequest {
  role?: VendorUserRoles
  tier?: VendorUserTiers
  resend_invitation?: boolean
  is_public?: boolean
  is_active?: boolean
}

interface InviteRequest {
  email: string
  role?: VendorUserRoles
}

export async function index() {
  return await axios.get<IndexVendorUserResponse>('/vendor/vendor_users')
}

export async function update_user(id: string, payload: UpdateRequest) {
  return await axios.patch(`/vendor/vendor_users/${id}`, { vendor_user: payload })
}

export async function invite_user(payload: InviteRequest) {
  return await axios.post('/vendor/users/invitation', { vendor_user: payload })
}
